/* Desktop menu panels: open on hover with a short delay, dim the page */
(function () {
  var header = document.querySelector('[data-header]');
  var backdrop = document.querySelector('[data-mega-backdrop]');
  var items = document.querySelectorAll('[data-dnav-item].has-panel');
  if (!header || !items.length) return;
  var openTimer, closeTimer, current = null;
  var open = function (item) {
    if (current === item) return;
    if (current) { current.classList.remove('is-open'); current.querySelector('.dnav__link').setAttribute('aria-expanded', 'false'); }
    current = item;
    item.classList.add('is-open');
    item.querySelector('.dnav__link').setAttribute('aria-expanded', 'true');
    header.classList.add('is-mega');
    if (backdrop) backdrop.classList.add('is-visible');
  };
  var close = function () {
    if (current) { current.classList.remove('is-open'); current.querySelector('.dnav__link').setAttribute('aria-expanded', 'false'); }
    current = null;
    header.classList.remove('is-mega');
    if (backdrop) backdrop.classList.remove('is-visible');
  };
  items.forEach(function (item) {
    item.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      openTimer = setTimeout(function () { open(item); }, current ? 0 : 90);
    });
    item.addEventListener('focusin', function () { open(item); });
  });
  document.querySelectorAll('[data-dnav-item]:not(.has-panel)').forEach(function (item) {
    item.addEventListener('mouseenter', function () { clearTimeout(openTimer); close(); });
  });
  header.addEventListener('mouseleave', function () {
    clearTimeout(openTimer);
    closeTimer = setTimeout(close, 120);
  });
  header.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  if (backdrop) backdrop.addEventListener('click', close);
})();
